// extracted by mini-css-extract-plugin
export default {"container":"src-signer-app-signature-request-field-tooltip-module__container--1SVE6","footer":"src-signer-app-signature-request-field-tooltip-module__footer--1upKj"};